import { Route, Routes } from "react-router-dom";
import NoMatch from "components/NoMatch";
import SingleLoanViewModeratorFormPage2 from "pages/SingleLoanViewModeratorFormPage2";
import TenderClosed from "components/TenderClosed";
import ModeratorBankLogin from "pages/ModeratorBankLogin";

const AnonymousRoutes = () => (
    <>
        <Routes>
            <Route path="/pankki/:tender_req_id" element={<SingleLoanViewModeratorFormPage2 />} />
            <Route path="/tender-closed" element={<TenderClosed />} />
            <Route path="*" element={<NoMatch />} />
            <Route path="/pankki" element={<ModeratorBankLogin />} />
        </Routes>
    </>
)

export default AnonymousRoutes